import React from "react";
import { legacyPillars } from "../../mock";

export default function LegacyPillars() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-gold font-semibold tracking-[0.2em] uppercase text-sm">
            Your Path To Financial Freedom
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-navy mt-3">
            Build, Grow and Protect Your Family &amp; Legacy
          </h2>
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-7">
          {legacyPillars.map((p) => (
            <div
              key={p.number}
              className="relative bg-cream rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-shadow overflow-hidden"
            >
              <div className="absolute -top-4 -right-2 font-serif text-8xl font-bold text-gold/10 select-none">
                {p.number}
              </div>
              <div className="relative">
                <div className="h-1.5 w-12 bg-gold rounded-full" />
                <h3 className="mt-5 font-serif text-2xl font-bold text-navy">
                  {p.title}
                </h3>
                <p className="mt-3 text-gray-600 leading-relaxed">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
